module.exports = __webpack_public_path__ + "img/20191113160748634.5b24a8b8.jpg";